/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionalLifestyleResponseDto
 */
export interface FunctionalLifestyleResponseDto {
    /**
     * Patient identity
     * @type {string}
     * @memberof FunctionalLifestyleResponseDto
     */
    patientId: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionalLifestyleResponseDto
     */
    questionnaireResponseId?: string;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    energyLevels: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    mentalClarityFocus: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    moodEmotionalWellbeing: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    libidoSexualHealth: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    digestion: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    immuneFunction: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    fitnessLevel: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    skinAppearance: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    hairHealth: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleResponseDto
     */
    sleep: number;
    /**
     * Additional information about the functional lifestyle
     * @type {string}
     * @memberof FunctionalLifestyleResponseDto
     */
    additionalInformation?: string;
}

/**
 * Check if a given object implements the FunctionalLifestyleResponseDto interface.
 */
export function instanceOfFunctionalLifestyleResponseDto(value: object): value is FunctionalLifestyleResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('energyLevels' in value) || value['energyLevels'] === undefined) return false;
    if (!('mentalClarityFocus' in value) || value['mentalClarityFocus'] === undefined) return false;
    if (!('moodEmotionalWellbeing' in value) || value['moodEmotionalWellbeing'] === undefined) return false;
    if (!('libidoSexualHealth' in value) || value['libidoSexualHealth'] === undefined) return false;
    if (!('digestion' in value) || value['digestion'] === undefined) return false;
    if (!('immuneFunction' in value) || value['immuneFunction'] === undefined) return false;
    if (!('fitnessLevel' in value) || value['fitnessLevel'] === undefined) return false;
    if (!('skinAppearance' in value) || value['skinAppearance'] === undefined) return false;
    if (!('hairHealth' in value) || value['hairHealth'] === undefined) return false;
    if (!('sleep' in value) || value['sleep'] === undefined) return false;
    return true;
}

export function FunctionalLifestyleResponseDtoFromJSON(json: any): FunctionalLifestyleResponseDto {
    return FunctionalLifestyleResponseDtoFromJSONTyped(json, false);
}

export function FunctionalLifestyleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalLifestyleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'questionnaireResponseId': json['questionnaireResponseId'] == null ? undefined : json['questionnaireResponseId'],
        'energyLevels': json['energyLevels'],
        'mentalClarityFocus': json['mentalClarityFocus'],
        'moodEmotionalWellbeing': json['moodEmotionalWellbeing'],
        'libidoSexualHealth': json['libidoSexualHealth'],
        'digestion': json['digestion'],
        'immuneFunction': json['immuneFunction'],
        'fitnessLevel': json['fitnessLevel'],
        'skinAppearance': json['skinAppearance'],
        'hairHealth': json['hairHealth'],
        'sleep': json['sleep'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
    };
}

export function FunctionalLifestyleResponseDtoToJSON(json: any): FunctionalLifestyleResponseDto {
    return FunctionalLifestyleResponseDtoToJSONTyped(json, false);
}

export function FunctionalLifestyleResponseDtoToJSONTyped(value?: FunctionalLifestyleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'questionnaireResponseId': value['questionnaireResponseId'],
        'energyLevels': value['energyLevels'],
        'mentalClarityFocus': value['mentalClarityFocus'],
        'moodEmotionalWellbeing': value['moodEmotionalWellbeing'],
        'libidoSexualHealth': value['libidoSexualHealth'],
        'digestion': value['digestion'],
        'immuneFunction': value['immuneFunction'],
        'fitnessLevel': value['fitnessLevel'],
        'skinAppearance': value['skinAppearance'],
        'hairHealth': value['hairHealth'],
        'sleep': value['sleep'],
        'additionalInformation': value['additionalInformation'],
    };
}

